<template>
  <div class="flex flex-col h-full">
    <topbar title="Iscriviti" :menu="false" :showBack="true" @back="$router.push({name: 'AuthStart'})" />
    <div class="flex flex-col justify-center flex-1 p-3 mx-auto max-w-2xl w-full ">
      <div class="flex flex-col items-stretch">
        <button class="btn btn-1 my-1" @click="socialRegister('facebook')">
          {{$t('register.register-with-facebook')}}
        </button>
        <button class="btn btn-1 my-1" @click="socialRegister('google')">
          {{$t('register.register-with-google')}}
        </button>

        <button class="btn btn-2 my-1" @click="emailRegister" >
          {{$t('register.register-with-email')}}
        </button>
      </div>
      
      <div class="flex my-2 items-center">
        <p>
          Continuando accetti le condizioni sul<br>
          <span class="underline" @click="$refs.pp.show()">trattamento dei dati personali</span>
        </p>
      </div>
    </div>

    <PrivacyPolicy @accept="accept(true)" @reject="accept(false)" ref="pp" />
  </div>
</template>

<script>
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'

export default {
  data() {
    return {
      acceptingpp: false,
    }
  },
  components: {
    PrivacyPolicy
  },
  methods: {
    emailRegister() {
      this.$router.push({name: 'EmailRegister'})
    },
    async socialRegister(providerId) {
      await this.$store.dispatch('loginSocial', providerId)
      this.$router.push({name: 'Overview'})
    },
    async twitterRegister() {
      console.info('not implemented')
    },
    
    
    accept(v) {
      this.$refs.pp.hide()
      this.acceptingpp = v
    },
  }
}
</script>

<style scoped>

</style>